<template>
  <label
    :class="classes"
    :for="name"
    @click="click"
  >
    <slot />

    <span
      v-if="required"
      class="cordel-label-required"
    >
      *
    </span>

    <context-loading
      v-if="loading"
      class="cordel-label-loading"
    />
  </label>
</template>

<script>
  import ContextLoading from '@cordel/components/Context/Loading.vue';

  export default {
    name: 'CordelLabel',
    components: {
      ContextLoading,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      classes() {
        const classes = ['cordel-label'];

        if (this.disabled) {
          classes.push('state--disabled');
        }

        if (this.loading) {
          classes.push('state--loading');
        }

        if (this.errors.length) {
          classes.push('state--error');
        }

        return classes;
      },
    },
    methods: {
      click(e) {
        this.$emit('click', e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-label {
    align-items: center;
    flex-direction: row;
    display: flex;
    justify-content: flex-start;
    margin-bottom: var(--cordel-legacy-spacing-micro);
  }

  .state--error {
    color: var(--cordel-legacy-color-alert-danger);
  }

  .state--disabled {
    color: var(--cordel-legacy-color-neutral-primary);
  }

  .cordel-label-required {
    color: var(--cordel-legacy-color-alert-danger);

    .state--disabled & {
      color: var(--cordel-legacy-color-neutral-primary);
    }
  }

  .cordel-label-loading {
    margin-left: var(--cordel-legacy-spacing-micro);
  }
</style>
